// extracted by mini-css-extract-plugin
export default {"form":"IULtXWKV","mobile":"mobile","row":"anWUw70O","field":"o9dKixp6","footer":"jPrM8W7L","errorMessage":"d4iLtlaN"};